import React, { useState } from "react";
import styled from "styled-components";
import {
  MainContainer,
} from "../Pages/OnBoarding/components/Common/Common";
import { Header } from "Pages/OnBoarding/components";
import { useNavigate } from "react-router-dom";

import PanCardImage from "../assets/pan-card.svg";
const ProgressBar = styled.div`
  width: 100%;
  height: 4px;
  background: #e0e0e0;
  position: relative;
  margin-bottom: 20px;
  &::after {
    content: "";
    position: absolute;
    width: 80%;
    height: 100%;
    background: black;
  }
`;

const Content = styled.main<{ type?: string }>`
 
  align-items: center;
  flex-direction: column;
`;

const Footer = styled.footer`
  padding: 0;
  margin-top: auto;
  margin-bottom: 20px;
`;
const Title = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: black;
  margin-bottom: 10px;
`;

const CustomInput = styled.input`
  padding: 12px;
  font-size: 16px;
  width: 93%;
  border: 1px solid #ccc;
  border-radius: 5px;
  text-align: left;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const SkipButton = styled.button`
  background: none;
  border: none;
  color: gray;
  font-size: 16px;
`;

const ProceedButton = styled.button<{ disabled?: boolean }>`
  width: 60%;
  padding: 12px;
  font-size: 16px;
  background-color: ${(props) => (props.disabled ? "#d3d3d3" : "#070505")};
  color: ${(props) => (props.disabled ? "#a9a9a9" : "white")};
  border: none;
  border-radius: 4px;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  transition: background-color 0.3s;
`;

const Description = styled.p<{ type?: string }>`
  font-size: 17px;
  color: rgb(0, 0, 0);
  margin-bottom: 16px;
  line-height: 25px;
  text-align: left;
`;

const   PanCard = () => {
  const [pan] = useState("BAJPC4350M");
  const navigate = useNavigate();

  const handleShowCibilScore = () => {
    navigate("/finalScore");
  };
  return (
    <>
      <Header />
      <MainContainer style={{ backgroundColor: "#F4F3EF", minHeight: "88vh" }}>
        <ProgressBar />
        <Content>
          <img
            src={PanCardImage}
            alt="pan-card"
            style={{ width: "-webkit-fill-available" }}
          />

          <Title>PAN Details</Title>
          <Description>
            Your PAN details have been successfully fetched from the HDFC Life
            server to calculate the Financial score.
          </Description>
          <CustomInput value={pan} readOnly maxLength={10} />
        </Content>
        <Footer>
          <ButtonGroup>
            <SkipButton>
              Skip <br /> <span style={{ fontSize: "11px" }}>For demo Use</span>{" "}
            </SkipButton>
            <ProceedButton onClick={handleShowCibilScore}>Next</ProceedButton>
          </ButtonGroup>
        </Footer>
      </MainContainer>
    </>
  );
};

export default PanCard;
